import React from 'react';

const BundleOfferModal = ({ isOpen, onClose, onSelectBundle, listingId }) => {
  const bundle = {
    id: 'quick-sale',
    title: '🔥 Gyors Eladás Csomag',
    originalPrice: 30970,
    price: 19990,
    savings: 10980,
    savingsPercent: 35,
    duration: '⏰ 10 perc múlva lejár!',
    includes: [
      {
        icon: '🚀',
        name: 'PRO Boost',
        value: '7.990 Ft',
        benefit: '3x több érdeklődő'
      },
      {
        icon: '🎬',
        name: 'AI Videó',
        value: '2.990 Ft',
        benefit: '+35% gyorsabb eladás'
      },
      {
        icon: '🎨',
        name: '5 AI Staging',
        value: '3.990 Ft',
        benefit: 'Professzionális megjelenés'
      }
    ]
  };

  const handleSelect = () => {
    onSelectBundle(bundle);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
      <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto border-2 border-yellow-500/30 shadow-2xl">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500 p-6 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div>
              <div className="inline-block bg-white/20 text-white text-xs font-black px-3 py-1 rounded-full mb-2">
                {bundle.duration}
              </div>
              <h2 className="text-2xl md:text-3xl font-black text-white mb-2">
                {bundle.title}
              </h2>
              <p className="text-white/90">
                Minden, ami kell a gyors eladáshoz - 35% kedvezménnyel
              </p>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:bg-white/20 rounded-full p-2 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Price */}
          <div className="bg-gradient-to-br from-yellow-500/20 to-orange-500/20 backdrop-blur-xl rounded-2xl p-6 border-2 border-yellow-500/30 mb-6 text-center">
            <div className="text-gray-300 text-sm mb-2 line-through">
              {bundle.originalPrice.toLocaleString()} Ft
            </div>
            <div className="text-5xl font-black text-white mb-2">
              {bundle.price.toLocaleString()} Ft
            </div>
            <div className="inline-block bg-green-500 text-white text-sm font-black px-4 py-2 rounded-full">
              -{bundle.savingsPercent}% ({bundle.savings.toLocaleString()} Ft megtakarítás)
            </div>
          </div>

          {/* Includes */}
          <div className="mb-6">
            <h3 className="text-white font-black text-lg mb-4">📦 Mit tartalmaz?</h3>
            <div className="space-y-3">
              {bundle.includes.map((item, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-xl p-4 border border-white/[0.08]"
                >
                  <div className="flex items-start justify-between">
                    <div className="flex items-start gap-3">
                      <div className="text-3xl">{item.icon}</div>
                      <div>
                        <h4 className="text-white font-bold">{item.name}</h4>
                        <p className="text-gray-300 text-sm">{item.benefit}</p>
                      </div>
                    </div>
                    <div className="text-gray-400 text-sm font-semibold">
                      {item.value}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Benefits */}
          <div className="bg-gradient-to-r from-green-500/20 to-emerald-500/20 backdrop-blur-xl rounded-xl p-6 border border-green-500/30 mb-6">
            <h3 className="text-white font-black text-lg mb-4">✨ Miért éri meg?</h3>
            <div className="grid grid-cols-2 gap-4 text-center">
              <div>
                <div className="text-3xl font-black text-white mb-1">+300%</div>
                <div className="text-gray-300 text-sm">Több megtekintés</div>
              </div>
              <div>
                <div className="text-3xl font-black text-white mb-1">3x</div>
                <div className="text-gray-300 text-sm">Több érdeklődő</div>
              </div>
              <div>
                <div className="text-3xl font-black text-white mb-1">60%</div>
                <div className="text-gray-300 text-sm">Gyorsabb eladás</div>
              </div>
              <div>
                <div className="text-3xl font-black text-white mb-1">35%</div>
                <div className="text-gray-300 text-sm">Megtakarítás</div>
              </div>
            </div>
          </div>

          {/* Urgency */}
          <div className="bg-gradient-to-r from-red-500/20 to-pink-500/20 backdrop-blur-xl rounded-xl p-4 border border-red-500/30 mb-6">
            <div className="flex items-center gap-3">
              <span className="text-2xl">⏰</span>
              <div>
                <h4 className="text-white font-bold mb-1">Limitált ajánlat!</h4>
                <p className="text-gray-300 text-sm">
                  Ez az ajánlat csak <strong className="text-white">10 percig</strong> érhető el feltöltés után
                </p>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-4">
            <button
              onClick={onClose}
              className="flex-1 bg-white/10 hover:bg-white/20 text-white font-bold py-4 rounded-xl transition-colors border-2 border-white/[0.08]"
            >
              Kihagyom
            </button>
            <button
              onClick={handleSelect}
              className="flex-1 bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500 hover:from-red-500 hover:to-yellow-500 text-white font-black py-4 rounded-xl shadow-xl hover:shadow-2xl hover:shadow-yellow-500/50 transition-all animate-pulse"
            >
              Megveszem most! 🔥
            </button>
          </div>

          {/* Guarantee */}
          <div className="text-center mt-4">
            <p className="text-gray-400 text-sm">
              ✓ 30 napos pénzvisszafizetési garancia
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BundleOfferModal;
